export const redirectUrl = redirect_url => {
  try {
    window.location.replace(redirect_url)
  } catch (e) {
    console.error('redirect_url' + ': ' + e)
  }
}
